import React from 'react';
import SelfPacedQuestionHeader from './self-paced-question-header';
import SelfPacedRangeSelection from './self-paced-range-selection';
import SelfPacedMultipleSelect from './self-paced-multiple-select';

function SelfPacedQuestion(question) {
  const q = question;
  const questionType = q.question.question.anchoring.type.toLowerCase();
  const isRangeQuestion = questionType === 'number' || questionType === 'age';

  return (
    <>
      <SelfPacedQuestionHeader question={question} />
      {isRangeQuestion && <SelfPacedRangeSelection question={question} />}
      {!isRangeQuestion && <SelfPacedMultipleSelect question={question} />}
    </>
  );
}

export default SelfPacedQuestion;
